<p-table [value]="sstsDataTransportistasPending.transportistas" [scrollable]="true"
scrollHeight="35vh" [rowHover]="true" [tableStyle]="{ 'min-width': '50rem' }"
styleClass="p-datatable p-datatable-striped ">
  <ng-template pTemplate="header">
    <tr>
      <th>Transportista</th>
      <th style="font-size: 0.7rem;" *ngFor="let col of programadores">{{ col }}</th>
      <th>Total</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td  style="font-size: 0.2rem;">
        <p class="">
          {{ row.nombre }}
        </p>
        </td>
      <td *ngFor="let col of programadores">
        {{ row.deudasPorProgramador[col] || '' }}
      </td>
      <td>{{ row.total }}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer">
    <tr>
      <td><strong>Total general</strong></td>
      <td *ngFor="let col of programadores">
        {{ sstsDataTransportistasPending.totalPorProgramador[col] }}
      </td>
      <td><strong>{{ sstsDataTransportistasPending.totalGeneral }}</strong></td>
    </tr>
  </ng-template>
</p-table>
